import axios from "axios";
import { useEffect, useState } from "react";

// export const baseUrl = "https://api.fleetassist.in/public/api/";
// export const mediaUrl = "https://api.fleetassist.in/storage/app/public/uploads";
// export const baseUrl = "http://192.168.1.72:8000/api/";
// export const mediaUrl = "http://192.168.1.72:8000/storage/uploads";
export const baseUrl = "https://entertainment.fleetassist.in/public/api/";
export const mediaUrl = "https://entertainment.fleetassist.in/storage/uploads";
// export const baseUrl = "http://localhost:8000/api/";
// export const mediaUrl = "http://localhost:8000/storage/uploads";

export const uploadFile = async (image, maxSizeBytes = 2 * 1024 * 1024) => {
  // 1. Get token from localStorage
  const token = localStorage.getItem("token");

  // 2. Check if token exists
  if (!token) {
    console.error("No token found in localStorage");
    throw new Error("Unauthorized: Token not found");
  }

  // 3. Client-side file size validation
  if (image && image.size && image.size > maxSizeBytes) {
    const sizeInMB = (maxSizeBytes / (1024 * 1024)).toFixed(0);
    const errorMsg = `File size is too large. Maximum allowed size is ${sizeInMB}MB.`;
    throw {
      response: {
        data: {
          message: errorMsg,
        },
      },
      message: errorMsg,
    };
  }

  // 4. Create FormData and append image
  const formdata = new FormData();
  formdata.append("image", image);

  try {
    // 5. Send the request with Authorization header
    const file_response = await axios.post(`${baseUrl}fileupload`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });

    // 6. Return the filename from response
    const filename = file_response.data.filename;
    return filename;
  } catch (error) {
    console.error("File upload failed:", error.response || error.message);
    if (
      error.response &&
      (error.response.data?.message === "No file uploaded" ||
        error.response.status === 413 ||
        error.response.status === 400)
    ) {
      const sizeInMB = (maxSizeBytes / (1024 * 1024)).toFixed(0);
      const friendlyMsg = `File upload failed. The selected file exceeds the maximum allowed size (${sizeInMB}MB).`;
      if (!error.response.data) error.response.data = {};
      error.response.data.message = friendlyMsg;
    }
    throw error;
  }
};

const useCurrency = () => {
  const [currency, setCurrency] = useState("");

  useEffect(() => {
    const fetchCurrency = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${baseUrl}general_setting/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCurrency(response.data[0].currency);
      } catch (error) {
        console.error("Error fetching currency:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchCurrency();
  }, []);

  return { currency };
};

export default useCurrency;

export async function apiGet(endpoint) {
  const token = localStorage.getItem("token");

  // 2. Check if token exists
  if (!token) {
    console.error("No token found in localStorage");
    throw new Error("Unauthorized: Token not found");
  }
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function apiPost(endpoint, body = {}) {
  const token = localStorage.getItem("token");

  // 2. Check if token exists
  if (!token) {
    console.error("No token found in localStorage");
    throw new Error("Unauthorized: Token not found");
  }
  const response = await axios.post(`${baseUrl}${endpoint}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}